import type { AccountTypePillProps } from './AccountTypePill.types';
import styles from './AccountTypePill.module.css';

/**
 * Maps tier to CSS class
 */
const TIER_CLASS_MAP = {
  Free: styles.free,
  Basic: styles.basic,
  Pro: styles.pro,
} as const;

/**
 * AccountTypePill Component
 *
 * Displays a pill/badge showing the user's subscription tier.
 * Text is language-independent (no translations).
 * Each tier has a distinct color for visual differentiation.
 */
export function AccountTypePill({ tier, className }: AccountTypePillProps) {
  const tierClass = TIER_CLASS_MAP[tier];

  return (
    <span className={`${styles.pill} ${tierClass} ${className ?? ''}`}>
      {tier}
    </span>
  );
}
